import client from '../../client';

const VISITS = {
  getVisits(propertyId) {
    return client.get(`/properties/${propertyId}/visits`);
  }
}

export default VISITS;
